import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, Link, graphql } from "gatsby"
import styled from "styled-components"
import themeConfig from "utils/theme-config"
const { screens } = themeConfig

const Logo = props => {
  const { className, path, siteDescription, siteTitle } = props
  const data = useStaticQuery(graphql`
    query LogoSvgQuery {
      allFile(
        filter: {
          name: { eq: "logo-rectangle" }
          extension: { eq: "svg" }
          relativeDirectory: { eq: "" }
        }
      ) {
        nodes {
          publicURL
        }
      }
      allSitePlugin(filter: { name: { eq: "@bufox/gatsby-theme-dry" } }) {
        nodes {
          pluginOptions
          name
        }
      }
    }
  `)
  const { useLogo = false, useDescription = true } =
    data.allSitePlugin.nodes[0].pluginOptions

  return (
    <div className={className}>
      <h1 className="site-title">
        {useLogo ? (
          <Link to={path} className="site-title-link">
            {data?.allFile?.nodes?.length > 0 ? (
              <div className="site-logo">
                <img src={data.allFile.nodes[0].publicURL} />
              </div>
            ) : (
              { siteTitle }
            )}
          </Link>
        ) : (
          <>
            <h1>
              <Link to={path} className="site-title-link">
                {siteTitle}
              </Link>
            </h1>
          </>
        )}
      </h1>
      {useDescription && (
        <div className="site-description">{siteDescription}</div>
      )}
    </div>
  )
}

Logo.propTypes = {
  className: PropTypes.string,
  location: PropTypes.object,
  logoLink: PropTypes.string,
  path: PropTypes.string,
  siteDescription: PropTypes.string,
  siteTitle: PropTypes.string,
}

const StyledLogo = styled(Logo)`
  display: flex;
  flex-direction: column;
  text-align: center;
  h1 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .site-title-link {
    font-size: 6vw;
    line-height: 2.5rem;
    font-weight: 700;
    text-transform: uppercase;
  }

  .site-logo > img {
    height: 3rem;
    max-width: 80%;
    margin: 0 auto;
    width: auto;
  }

  .site-description {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  @media only screen and (min-width: ${screens.lg}) {
    text-align: left;
    h1 {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
    }
    .site-logo > img {
      height: 2rem;
      max-width: 25rem;
      margin: 1rem 0;
    }
    .site-description {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
    }

    .site-title-link {
      font-size: 2.25rem;
    }
  }
`

export default StyledLogo
export { Logo }
